import React, { useEffect, useState } from "react";
import ajax from "superagent";
import MultiSelectInput from "../../../AlbumTag/components/MultiSelectInput";
import "../../../AlbumTag/styles/style.css";

type AppliedTag = { name: string; tagId: number; taggableType: string };

interface BundleMediaSelectProps {
  mediaCount: number;
  contentTagsAPI: string;
  handleClose: Function;
  listOfMediaId: Array<{ id: number; hidden: boolean }>;
  handlePostCall: Function;
  arrayOfIds?: Array<number>;
}

const BundleMediaSelect = ({
  mediaCount,
  contentTagsAPI,
  handleClose,
  listOfMediaId,
  handlePostCall,
  arrayOfIds
}: BundleMediaSelectProps) => {
  const photoIds = arrayOfIds || listOfMediaId.map(val => val.id);
  const singlePhotoId = photoIds.length === 1 ? photoIds[0] : null;
  const [appliedTags, setAppliedTags] = useState<AppliedTag[] | null>(
    singlePhotoId ? null : []
  );

  useEffect(() => {
    if (!singlePhotoId) return;

    ajax
      .get(`/api/v1/content_tags/${singlePhotoId}`)
      .then(response => setAppliedTags(response.body.appliedTags))
      .catch(error => {
        // @ts-ignore
        toastr.error("There was an error loading tags");
        console.error(error);
        setAppliedTags([]);
      });
  }, [singlePhotoId]);

  return (
    <div>
      <div
        id="album-tag-modal-dialog"
        className="modal fade in geo-modal geo-modal--small geo-modal--scroll geo-modal--show"
        role="dialog"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add tags to photos</h5>
              <button className="close" onClick={() => handleClose()}>
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="album-name-div">
                <span className="album-modal-sub sub-2-font">
                  {mediaCount}{" "}
                  {mediaCount === 1 ? "photo selected" : "photos selected"}
                </span>
              </div>
              {appliedTags && (
                <MultiSelectInput
                  appliedTags={appliedTags}
                  contentTagsAPI={contentTagsAPI}
                  handleClose={handleClose}
                  tagType={"photo"}
                  photoId={photoIds}
                  handlePostCall={handlePostCall}
                  parentName={"event-gallery-curate"}
                  blockEdit={"album"}
                />
              )}
            </div>
          </div>
        </div>
      </div>{" "}
      <div className="modal-backdrop fade in" />
    </div>
  );
};

export default BundleMediaSelect;
